import { getRequest } from './api';

const forusEventsApi = {
  // Filas horarias de la org del usuario (las 8 marcas + ventana YoY -364d).
  // orgId: solo lo honra el backend si el usuario es admin (para mirar el panel de otra org).
  async getHourly(start, end, orgId) {
    const org = orgId ? `&org_id=${orgId}` : '';
    const res = await getRequest(`/forus-events/hourly?start=${start}&end=${end}${org}`);
    return res?.data ?? res;
  },
};

export default forusEventsApi;
